export type StrainLevel = 'low' | 'moderate' | 'high' | 'peak';

export interface StrainLabel {
  label: string;
  level: StrainLevel;
}

export function strainLabel(avg: number | null): StrainLabel | null {
  if (avg === null || avg === undefined) return null;
  if (avg < 10) return { label: 'Низкая', level: 'low' };
  if (avg < 14) return { label: 'Средняя', level: 'moderate' };
  if (avg < 18) return { label: 'Высокая', level: 'high' };
  return { label: 'Пиковая', level: 'peak' };
}
